import {JobActivityItemsType} from "../components/job/activityStream/JobActivityStream";
import {LeadActivityItemsType} from "../components/activityStream/LeadActivityStream";
import {InvoiceActivityItemsType} from "../components/accounting/activityStream/InvoiceActivityStream";

type ActivityItemsType = JobActivityItemsType | LeadActivityItemsType | InvoiceActivityItemsType;

export default class ActivityStreamUtils {

	/**
	 * Sort job and lead activity stream items by creation date
	 * @param {ActivityItemsType} a first item
	 * @param {ActivityItemsType} b second item
	 * @return {number} sort order
	 */
	public static sort(a: ActivityItemsType, b: ActivityItemsType) {
		return a.getCreationDate().isBefore(b.getCreationDate()) ? 1 : -1
	}
}